import Papa, { ParseResult } from "papaparse";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { createTopSkill } from "../core/data/redux/employee/employeeAction";

export const useSkillCSVImport = (
    setTableKey: React.Dispatch<React.SetStateAction<number>>
) => {
    const dispatch = useDispatch<any>();
    const { user } = useSelector((state: any) => state.auth);

    const handleSkillCSVImport = (file: File) => {
        message.loading({ content: "Importing skills...", key: "skill_import" });

        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,

            complete: async function (results: ParseResult<any>) {
                const rows = results.data as any[];

                let valid = 0;
                let invalid = 0;

                for (let row of rows) {
                    const employeeId =
                        row.EmployeeId || row.EmployeeID || row.employeeID;

                    if (!employeeId) {
                        invalid++;
                        continue;
                    }

                    // Build Skill Payload
                    const skillPayload = {
                        SkillName: row.SkillName,
                        ProficiencyScore: Number(row.ProficiencyScore),
                        CreatedBy: row.CreatedBy || user?.id,
                    };

                    const response = await dispatch(
                        createTopSkill({
                            employeeId,
                            topSkillData: skillPayload,
                        })
                    );

                    if (createTopSkill.rejected.match(response)) invalid++;
                    else valid++;
                }

                setTableKey((prev) => prev + 1);

                message.success({
                    content: `Skill Imported: ${valid}, Skipped: ${invalid}`,
                    key: "skill_import",
                    duration: 3,
                });
            },
        });
    };

    return { handleSkillCSVImport };
};
